(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.collapse-header[data-v-2ba004a0]{display:flex;align-items:center;justify-content:space-between;height:40px;padding:0 16px}.collapse-content-area[data-v-2ba004a0]{max-height:0;overflow:auto;transition:max-height .4s}.open.collapse-content-area[data-v-2ba004a0]{max-height:4000px;transition:max-height .4s}.collapse-content-area .collapse-content[data-v-2ba004a0]{padding:16px;border-radius:6px}.collapse-header[data-v-2ba004a0]{width:100%;color:#fff;background-color:#6c6c6c;border-radius:6px}.collapse-header .collapse-header-text[data-v-2ba004a0]{cursor:pointer}.collapse-content-area .collapse-content[data-v-2ba004a0]{background-color:#fff}.collapse-content-area .collapse-content .collapse-data[data-v-2ba004a0]{position:relative;margin:0 16px}.collapse-content-area .collapse-content .collapse-data.open[data-v-2ba004a0]:before{position:absolute;top:11px;left:-16px;width:0;height:0;content:"";border-top:6px solid black;border-right:5px solid transparent;border-left:5px solid transparent}.collapse-content-area .collapse-content .collapse-data.close[data-v-2ba004a0]:before{position:absolute;top:10px;left:-14px;width:0;height:0;content:"";border-top:5px solid transparent;border-bottom:5px solid transparent;border-left:6px solid black}.zod-content .collapse-area .collapse-header[data-v-555e9246]{display:flex;align-items:center;justify-content:space-between;height:40px;padding:0 16px}.zod-content .collapse-area .collapse-content-area[data-v-555e9246]{max-height:0;overflow:auto;transition:max-height .4s}.zod-content .collapse-area .open.collapse-content-area[data-v-555e9246]{max-height:4000px;transition:max-height .4s}.zod-content .collapse-area .collapse-content-area .collapse-content[data-v-555e9246]{padding:16px;border-radius:6px}.zod-button .button-error-count[data-v-555e9246],.zod-content .collapse-area .collapse-header .collapse-header-title .collapse-header-error-count[data-v-555e9246]{width:20px;height:20px;font-size:12px;font-weight:600;line-height:20px;text-align:center;background-color:red;border-radius:50%}.zod-button[data-v-555e9246]{position:fixed;bottom:10px;left:10px;z-index:999999;width:70px;padding:4px 0;color:#fff;text-align:center;cursor:pointer;background-color:#000;border:1px solid white;border-radius:6px}.zod-button .button-error-count[data-v-555e9246]{position:absolute;top:-5px;right:-6px}.zod-content[data-v-555e9246]{position:fixed;bottom:0;z-index:999998;width:100%;height:60vh;padding:16px;overflow:auto;color:#fff;background-color:#000;opacity:.9}.zod-content .delete__button[data-v-555e9246]{position:fixed;right:20px;bottom:10px;padding:4px 16px;color:#fff;cursor:pointer;background-color:#000;border:1px solid white;border-radius:6px}.zod-content .collapse-area[data-v-555e9246]{width:100%;margin-bottom:24px;color:#000;word-break:break-all;background-color:#fff;border-radius:6px}.zod-content .collapse-area .collapse-header .collapse-header-title[data-v-555e9246]{display:flex;align-items:center}.zod-content .collapse-area .collapse-header .collapse-header-title .collapse-header-error-count[data-v-555e9246]{margin-right:10px;color:#fff}.zod-content .collapse-area .collapse-header .collapse-header-text[data-v-555e9246]{display:flex;column-gap:12px;cursor:pointer}.zod-content .collapse-area .collapse-header .collapse-header-text .collapse-header-text-delete[data-v-555e9246]{color:red}.zod-content .collapse-area .collapse-content-area .collapse-content[data-v-555e9246]{display:grid;row-gap:18px;margin:16px;background-color:#e0e0e0}.text-weight-500[data-v-555e9246]{font-size:16px;font-weight:500}.text-link[data-v-555e9246]{text-decoration:underline;text-underline-offset:6px}')),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
import { effectScope as I, inject as x, ref as j, computed as O, watch as W, defineComponent as M, onMounted as V, openBlock as p, createElementBlock as h, createElementVNode as r, toDisplayString as k, normalizeClass as N, Fragment as $, renderList as S, createBlock as R, resolveDynamicComponent as H, h as i, createTextVNode as K, unref as U, createVNode as L, createCommentVNode as P } from "vue";
const B = Symbol(), z = Symbol();
function q(u) {
  let l = !1, t;
  const f = I(!0);
  return (...s) => (l || (t = f.run(() => u(...s)), l = !0), t);
}
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const T = q(() => {
  const u = x(z, null), l = j("/"), t = j({}), f = O(() => t.value);
  function s(o) {
    y(o) ? o.item && (t.value[o.item] = o.data) : t.value = o.data;
  }
  function y(o) {
    return "item" in o;
  }
  function v(o, C) {
    const n = f.value[l.value];
    s(n ? {
      data: [
        ...n,
        {
          data: o,
          issue: C
        }
      ],
      item: l.value
    } : {
      data: {
        [l.value]: [
          {
            data: o,
            issue: C
          }
        ],
        ...f.value
      }
    });
  }
  return W(
    () => u == null ? void 0 : u.currentRoute.value.fullPath,
    (o) => {
      var C;
      if (l.value = o ?? "", (C = t.value) != null && C[l.value]) {
        const n = Object.fromEntries(
          Object.entries(t.value).filter(
            ([d]) => d !== l.value
          )
        );
        s({ data: n });
      }
    },
    { immediate: !0 }
  ), {
    errorData: f,
    setErrorData: s,
    setApiZodErrorData: v
  };
}), J = { class: "collapse-header" }, Q = { class: "collapse-content" }, X = /* @__PURE__ */ M({
  __name: "full-info",
  props: {
    data: {},
    showCollapse: {}
  },
  emits: ["handle-collapse"],
  setup(u, { emit: l }) {
    const t = u, f = l, s = j(o(t.data));
    function y(n, d) {
      return Object.entries(n).map(([m, b]) => {
        const g = b && typeof b == "object";
        let e = m;
        return d && (e = [d, m].join(".")), i(
          "div",
          {
            class: [
              "collapse-data",
              g ? s.value[e] ? "open" : "close" : ""
            ],
            onClick: (c) => {
              c.stopPropagation(), g && (s.value[e] ? Object.keys(s.value).forEach((a) => {
                a.startsWith(e) && (s.value[a] = !1);
              }) : s.value[e] = !0);
            }
          },
          [
            // h('div', `${key}:${JSON.stringify(value)}`),
            i("div", { style: "padding:2px" }, [
              i("span", `${m}: `),
              v(b)
            ]),
            i(
              "div",
              {
                class: [
                  "collapse-content-area",
                  s.value[e] ? "open" : "close"
                ]
              },
              [g ? y(b, e) : null]
            )
          ]
        );
      });
    }
    function v(n) {
      return typeof n == "number" || typeof n == "boolean" ? i("span", { style: "color:#004B97" }, n) : typeof n == "string" ? i("span", { style: "color:#FF0000" }, `"${n}"`) : n == null ? i("span", n) : Array.isArray(n) ? i("span", `Array(${n.length})`) : Object.keys.length ? i("span", [
        i("span", "{ "),
        ...Object.entries(n).map(([d, _]) => i("span", [
          i("span", { style: "color:#6c6c6c" }, `${d}: `),
          i(
            "span",
            typeof _ == "object" && _ != null && !Array.isArray(_) ? "{...}" : v(_)
          ),
          i("span", ", ")
        ])),
        i("span", "...}")
      ]) : i("span", "{}");
    }
    function o(n) {
      const d = {};
      return Object.entries(n).forEach(([_, m]) => {
        if (m && typeof m == "object") {
          const b = o(m);
          Object.keys(b).forEach((g) => {
            const e = [_, g].join(".");
            d[e] = !1;
          }), d[_] = !1;
        }
      }), d;
    }
    function C() {
      f("handle-collapse", t.data.apiUrl, !1), setTimeout(() => {
        s.value = o(t.data);
      }, 400);
    }
    return V(() => {
      s.value = o(t.data);
    }), (n, d) => (p(), h("div", null, [
      r("div", J, [
        d[0] || (d[0] = r("div", null, k("完整資訊"), -1)),
        r("div", {
          class: "collapse-header-text",
          onClick: C
        }, k(t.showCollapse.has(t.data.apiUrl) ? "收合" : "展開"), 1)
      ]),
      r("div", {
        class: N(["collapse-content-area", [{ open: t.showCollapse.has(t.data.apiUrl) }]])
      }, [
        r("div", Q, [
          (p(!0), h($, null, S(y(t.data), (_, m) => (p(), h("div", {
            key: m,
            class: "collapse-data"
          }, [
            (p(), R(H(() => _)))
          ]))), 128))
        ])
      ], 2)
    ]));
  }
}), F = (u, l) => {
  const t = u.__vccOpts || u;
  for (const [f, s] of l)
    t[f] = s;
  return t;
}, Y = /* @__PURE__ */ F(X, [["__scopeId", "data-v-2ba004a0"]]), ee = { class: "button-error-count" }, te = {
  key: 0,
  class: "zod-content"
}, ae = { class: "collapse-header" }, oe = { class: "collapse-header-title" }, ne = { class: "collapse-header-error-count" }, se = ["onClick"], le = { class: "collapse-header-text" }, re = ["onClick"], ce = ["onClick"], ie = { class: "collapse-content" }, ue = { class: "text-weight-500" }, de = { key: 1 }, pe = /* @__PURE__ */ M({
  __name: "index",
  setup(u) {
    const l = x(z, null), t = x(B, void 0), { errorData: f } = T(), { setErrorData: s } = T(), y = j(!1), v = j(/* @__PURE__ */ new Set([])), o = O(() => Object.entries(f.value ?? {})), C = O(() => o.value.map(
      ([c, a]) => [c, a.length]
    ).reduce(
      (c, [a, D]) => (c[a] = D, c.total = (c.total ?? 0) + D, c),
      {}
    )), n = O(() => {
      const { total: e } = C.value;
      return e ? e < 100 ? e : "N" : 0;
    });
    function d(e) {
      window.open(l == null ? void 0 : l.resolve({ path: e }).href, "_blank");
    }
    function _(e) {
      return ["data", ...e.map((a) => {
        if (typeof a == "number")
          return `[${a}]`;
        if (typeof a == "string") return `.${a}`;
      })].join("");
    }
    function m(e, c) {
      var a;
      if (v.value.has(e) ? v.value.delete(e) : v.value.add(e), c) {
        const D = (a = f.value[e]) == null ? void 0 : a.map(({ data: w }) => w.apiUrl);
        D == null || D.forEach((w) => {
          v.value.delete(w);
        });
      }
    }
    function b(e) {
      const c = Object.fromEntries(
        o.value.filter(([a]) => a !== e)
      );
      s({ data: e ? c : {} });
    }
    function g() {
      y.value || v.value.clear(), y.value = !y.value;
    }
    return (e, c) => (p(), h($, null, [
      r("div", {
        class: "zod-button",
        onClick: g
      }, [
        K(k(y.value ? "close" : "zod") + " ", 1),
        r("div", ee, k(n.value), 1)
      ]),
      y.value ? (p(), h("div", te, [
        (p(!0), h($, null, S(o.value, ([a, D], w) => (p(), h("div", {
          key: w,
          class: "collapse-area"
        }, [
          r("div", ae, [
            r("div", oe, [
              r("div", ne, k(C.value[a]), 1),
              r("div", {
                class: "text-link collapse-header-text",
                onClick: (E) => d(a)
              }, k(a), 9, se)
            ]),
            r("div", le, [
              r("div", {
                onClick: (E) => m(a, !0)
              }, k(v.value.has(a) ? "收合" : "展開"), 9, re),
              r("div", {
                class: "collapse-header-text-delete",
                onClick: (E) => b(a)
              }, " 刪除 ", 8, ce)
            ])
          ]),
          (p(!0), h($, null, S(D, (E, G) => (p(), h("div", {
            key: G,
            class: N(["collapse-content-area", [{ open: v.value.has(a) }]])
          }, [
            r("div", ie, [
              r("div", ue, k(`Api Url: ${E.data.apiUrl}`), 1),
              U(t) ? (p(), R(U(t), {
                key: 0,
                data: E.issue
              }, null, 8, ["data"])) : (p(), h("div", de, [
                (p(!0), h($, null, S(E.issue, (A, Z) => (p(), h("div", { key: Z }, [
                  r("span", null, k(`path: ${_(A.path)}, `), 1),
                  r("span", null, k(`message: "${A.message}"`), 1)
                ]))), 128))
              ])),
              L(Y, {
                data: E.data,
                "show-collapse": v.value,
                onHandleCollapse: m
              }, null, 8, ["data", "show-collapse"])
            ])
          ], 2))), 128))
        ]))), 128)),
        o.value.length ? (p(), h("div", {
          key: 0,
          class: "delete__button",
          onClick: c[0] || (c[0] = (a) => b())
        }, " 刪除全部 ")) : P("", !0)
      ])) : P("", !0)
    ], 64));
  }
}), fe = /* @__PURE__ */ F(pe, [["__scopeId", "data-v-555e9246"]]), he = {
  install: (u, l) => {
    const { isShow: t, customizeMessage: f, router: s } = l;
    u.provide(B, f), u.provide(z, s), u.component("zod-checker", t ? fe : {});
  }
};
export {
  fe as ZodChecker,
  he as default,
  T as useZodData
};
//# sourceMappingURL=zod-checker.js.map
